// Librerias
import React from 'react'
import ReactDOM from 'react-dom'
import api from '../apiClient/v1'
//let PropTypes = React.PropTypes
// Moment
import moment from 'moment'
let momentLocalizer = require('react-widgets/lib/localizers/moment')
momentLocalizer(moment)
// Validador Rut
import { validarRUN, obtenerVerificador } from '../shared/ValidadorRUN'
// Forms
import Form from 'react-formal'
import formalInputs from '../shared/react-formal-inputs/react-formal-inputs'
Form.addInputTypes(formalInputs)
import yup from 'yup'
// ReactNotify
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../shared/ReactNotify/ReactNotify.css'
// Componentes
import * as styles from './formularioUsuario.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(styles)
import PropTypes from 'prop-types';
import { ModalConfirmar, ModalUploadFiles } from './Modals.jsx'
import { EsDeRegion } from './esDeRegion.jsx'

const listaBancos = ['Banco Estado', 'Banco de Chile', 'Banco Internacional', 'Scotiank-Desarrollo',
    'Banco de Credito e Inversiones', 'CorpBanca', 'Banco Bice', 'HSBC Bank Chile', 'Banco Santander', 'Banco Itaú',
    'The Bank of Tokyo-Mitsubishi', 'Banco Security', 'Banco Falabella', 'Banco Ripley', 'Banco Consorcio', 'Banco Paris',
    'Banco BBVA', 'Copeuch', 'Banco Penta', 'Scotiabank Chile', 'Deutsche Bank', 'Rabobank Chile']
const listaTipoCuentas = ['Cuenta Corriente', 'Cuenta Vista', 'Cuenta Ahorro', 'Chequera Electronica', 'Cuenta de Gastos', 'Cuenta RUT']
const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

export class RegistroOperador extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            datos: [],
            region: "",
            comuna: "",
            captador: "",
            banco: "",
            cuenta: "",
            bcoEstado: false,
            ctaRut: false,
            comunas: [],
            captadores: [],
            cambioRegion: false,
            inputNacion: false,
            modalDNI: false,
            user: [],
            checkDNIFront: false,
            checkDNIBack: false,
            chekcFechaVenc: false,
            btnDocs: false,
            confirmando: false,
        }
        console.log(this.props.usuario)
        this.ajaxErrorHandler = (errorTitle) => {
            return (err) => {
                if (err.status == 500)
                    return this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4 * 1000);
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
            }
        }
        this.bcoEstado = (event) => {
            if (event.idBanco == 3) {
                this.setState({
                    bcoEstado: true
                })
            } else {
                this.setState({
                    bcoEstado: false
                })
            }
        }
        this.cuentaRut = (event) => {
            if (event.idCuenta == 5) {
                this.setState({
                    ctaRut: true
                })
            } else {
                this.setState({
                    ctaRut: false
                })
            }
        }
        this.changeRegion = (event) => {

            let comunasNuevas = this.props.usuario.comunas
                .filter(co => co.cutRegion == event.cutRegion)
            if (event.cutRegion == 1) {
                let captadoresNuevos = this.props.usuario.captadores.filter(ca => ca.nombre == 'Manuel  Mely')
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 2) {
                let captador1 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Cristina  Valencia ')
                let captador2 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Manuel  Mely')
                let captadoresNuevos = captador1.concat(captador2)
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 3) {
                let captadoresNuevos = this.props.usuario.captadores.filter(ca => ca.nombre == 'Manuel  Mely')
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 4) {
                let captadoresNuevos = this.props.usuario.captadores.filter(ca => ca.nombre == 'Manuel  Mely')
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 5) {
                let captadoresNuevos = this.props.usuario.captadores.filter(ca => ca.nombre == 'Ana Torres')
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 6) {
                let captadoresNuevos = this.props.usuario.captadores.filter(ca => ca.nombre == 'Marcia Espinoza')
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 7) {
                let captador1 = this.props.usuario.captadores.filter(ca => ca.nombre == 'RMaule VII')
                let captador2 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Marcia Espinoza')
                let captadoresNuevos = captador1.concat(captador2)
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 8) {
                //console.log(this.props.usuario.captadores);
                let captador1 = this.props.usuario.captadores.filter(ca => ca.nombre == 'SEI Concepción')
                let captador2 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Pamela Aedo')
                let captador3 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Marcia Espinoza')
                let captadoresNuevos = captador1.concat(captador2, captador3)
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 9) {
                let captadoresNuevos = this.props.usuario.captadores.filter(ca => ca.nombre == 'Pamela Aedo')
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 10) {
                let captador1 = this.props.usuario.captadores.filter(ca => ca.nombre == 'SEI SUR ')
                let captador2 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Pamela Aedo')
                let captador3 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Marcia Espinoza')
                let captadoresNuevos = captador1.concat(captador2, captador3)
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 11) {
                let captador1 = this.props.usuario.captadores.filter(ca => ca.nombre == 'SEI Coyhaique')
                let captador2 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Marcia Espinoza')
                let captadoresNuevos = captador1.concat(captador2)
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 12) {
                let captadoresNuevos = this.props.usuario.captadores.filter(ca => ca.nombre == 'Marcia Espinoza')
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 13) {
                let captadoresNuevos = this.props.usuario.captadores.filter(ca => ca.nombre == 'Región Metropolitana')
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 14) {
                let captador1 = this.props.usuario.captadores.filter(ca => ca.nombre == 'SEI SUR ')
                let captador2 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Pamela Aedo')
                let captador3 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Marcia Espinoza')
                let captadoresNuevos = captador1.concat(captador2, captador3)
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 15) {
                let captadoresNuevos = this.props.usuario.captadores.filter(ca => ca.nombre == 'Manuel  Mely')
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
            if (event.cutRegion == 16) {
                let captador1 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Nicolle Ortega')
                let captador2 = this.props.usuario.captadores.filter(ca => ca.nombre == 'Alicia Ríos')
                let captadoresNuevos = captador1.concat(captador2)
                this.setState({
                    comunas: comunasNuevas,
                    captadores: captadoresNuevos,
                    cambioRegion: true
                })
            }
        }
        this.changeNacionalidad = (event) => {
            if (event == 'Otra') {
                this.setState({
                    inputNacion: true
                })
            } else {
                this.setState({
                    inputNacion: false
                })
            }
        }
        this.mostrarModal = (datos) => {
            if (!datos.idBanco || !datos.idTipoCuenta || !datos.sexo) {
                alert('NO OLVIDE LLENAR TODOS LOS CAMPOS')
            } else {
                let comuna = this.props.usuario.comunas.find(c => c.cutComuna == datos.cutComuna)
                let banco = this.props.usuario.bancos.find(b => b.idBanco == datos.idBanco)
                let cuenta = this.props.usuario.cuentas.find(t => t.idCuenta == datos.idTipoCuenta)
                let region = this.props.usuario.regiones.find(r => r.cutRegion == datos.cutRegion)
                let captador = this.props.usuario.captadores.find(ca => ca.idCaptador == datos.idCaptador)
                if (this.state.bcoEstado && this.state.ctaRut) {
                    datos.numeroCuenta = datos.usuarioRUN
                }
                this.setState({
                    showModal: true,
                    datos: datos,
                    comuna: comuna,
                    banco: banco,
                    cuenta: cuenta,
                    region: region,
                    captador: captador
                })
            }
            //console.log(datos)
        }
        this.showModalDocs = () => {
            this.setState({
                modalDNI: true,
                showModal: false
            })
        }
        this.cancelModal = () => {
            this.setState({
                showModal: false,
                datos: [],
                comuna: "",
                banco: "",
                cuenta: "",
                confirmando: false
            })
        }
        this.cancelModalDNI = () => {
            this.setState({
                modalDNI: false,
                user: []
            })
        }
        this.nuevoUsuario = (datos) => {
            this.setState({
                confirmando: true
            })
            let banco = this.props.usuario.bancos.find(banco => banco.idBanco == datos.idBanco)
            let tipoCuenta = this.props.usuario.cuentas.find(cuenta => cuenta.idCuenta == datos.idTipoCuenta)
            if (datos.nacionalidad == 'Otra') {
                datos.nacionalidad = datos.otraNacionalidad
            }
            datos.idBanco = banco.idBanco;
            datos.idTipoCuenta = tipoCuenta.idCuenta;
            api.usuarios.registrarOperador(datos)
                .then(resp => {
                    console.log(resp)
                    this.setState({
                        checkDNIFront: resp.existingCarnetFront ? true : false,
                        checkDNIBack: resp.existingCarnetBack ? true : false,
                        showModal: false,
                        datos: [],
                        comuna: "",
                        banco: "",
                        cuenta: "",
                        modalDNI: true,
                        user: resp,
                        btnDocs: true,
                        confirmando: false
                    })

                })
                .catch(err => {
                    console.log(err)
                    let errores = err.data
                    let mensaje = '';
                    for (const i in errores) {
                        mensaje += i + ": " + errores[i][0] + '\n'
                    }
                    alert(errores);
                })
        }
    }

    usuarioSchema = yup.object({
        usuarioRUN: yup.string().default(this.props.usuario.usuarioRUN)
            .min(1, 'El RUN debe tener un minimo de 1 caracteres')
            .max(8, 'El RUN debe tener un máximo de 8 caracteres'),
        usuarioDV: yup.string()
            .default(obtenerVerificador(this.props.usuario.usuarioRUN))
            .required('Ingrese el digito verificador del RUN')
            .test('verificarUsuarioDV', 'El digito verificador es incorrecto', function (value) {
                // Hack sucio... cuando se hace una validacion con delay, se sacan los valores de options, si no, de parent
                let valores = this.options.value ? this.options.value : this.parent
                return validarRUN(valores.usuarioRUN, value)
            })
            .max(1, 'El máximo es 1 digito'),
        emailPersonal: yup.string().default(this.props.usuario.emailPersonal)
            .max(60, 'El máximo es 60 caracteres')
            //.email('Debe ser un email valido'),
            .required('Ingrese el email')
            .test('correo', 'Debe ingresar un email valido', function (value) {
                var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
                return value === '' || rEmail.test(value)
            }),
        nombre1: yup.string().default(this.props.usuario.nombre1)
            .required('Ingrese el primer nombre')
            .min(3, 'El minimo es de 3 caracteres')
            .max(20, 'El máximo es 20 caracteres'),
        nombre2: yup.string().default(this.props.usuario.nombre2)
            .max(20, 'El máximo es 20 caracteres'),
        apellidoPaterno: yup.string().default(this.props.usuario.apellidoPaterno)
            .required('Ingrese el apellido')
            .min(3, 'El minimo es de 3 caracteres')
            .max(20, 'El máximo es 20 caracteres'),
        apellidoMaterno: yup.string().default(this.props.usuario.apellidoMaterno)
            .max(20, 'El máximo es 20 caracteres'),  // no obligatorio
        telefono: yup.string().default("")
            .max(20, 'El máximo es 20 caracteres')
            .required('Ingrese el teléfono de la persona'),
        telefonoEmergencia: yup.string().default("")
            .max(20, 'El máximo es 20 caracteres'),  // no obligatorio
        // TODO: este validador no permite que existan fechas "invalidas" como un string vacio, arreglar esto eventualmente....
        fechaNacimiento: yup.date().default(this.props.usuario.fechaNacimiento ? (this.props.usuario.fechaNacimiento === '0000-00-00' ? null : new Date(this.props.usuario.fechaNacimiento.replace(/-/g, '\/').replace(/T.+/, ''))) : null)
            .test('fechaNacimiento', 'Mensaje de error', function () {
                return true
            }),
        //.required('Ingrese la fecha de nacimiento'),
        sexo: yup.string().default(this.props.usuario.sexo)
            .required('Ingrese el sexo de la persona'),
        nacionalidad: yup.string().default(this.props.usuario.nacionalidad)
            .required('Ingrese la nacionalidad de la persona'),
        direccion: yup.string().default(this.props.usuario.direccion)
            .max(150, 'El máximo es de 150 carácteres')
            .required('Ingrese la dirección de la persona'),
        // cutRegion: yup.number()
        //     .required('Seleccione una Región'),
        cutComuna: this.props.usuario.cutComuna != 0 ? yup.number().default(parseInt(this.props.usuario.cutComuna))   // es un number, pero lo retornan como string
            .required('Seleccione una Comuna') : yup.string()   // es un number, pero lo retornan como string
                .required('Seleccione una Comuna'),
        idBanco: this.props.usuario.banco != 0 ? yup.number().default(parseInt(this.props.usuario.banco))
            .required('Seleccione el Banco de la lista') : yup.string()
                .required('Seleccione el Banco de la lista'),
        //.max(30, 'El máximo es 30 caracteres'),
        idTipoCuenta: this.props.usuario.cuenta != 0 ? yup.number().default(parseInt(this.props.usuario.cuenta))
            .required('Seleccione el Tipo de Cuenta de la lista') : yup.string()
                .required('Seleccione el Tipo de Cuenta de la lista'),
        //.max(30, 'El máximo es 30 caracteres'),
        numeroCuenta: yup.string().default(this.props.usuario.numeroCuenta)
            .required('Escriba el Número de Cuenta')
            .max(30, 'El máximo es 30 caracteres'),
        idCaptador: this.props.usuario.idCaptador != 0 ? yup.number().default(parseInt(this.props.usuario.idCaptador))
            .required('Seleccione su Captador') : yup.string()
                .required('Seleccione su Captador'),
        cutRegion: this.props.usuario.cutRegion != 0 ? yup.number().default(parseInt(this.props.usuario.cutRegion))
            .required('Seleccione una Region') : yup.string()
                .required('Seleccione una Region'),
        otraNacionalidad: yup.string()
            .required('Ingrese la nacionalidad de la persona'),
        /*DNIFront: yup.mixed()
            .required('Suba el archivo correspondiente'),*/
    })

    enviarFormularioInvalido(datos) {
        console.log('enviando invalido ', datos)
    }
    siguienteComponente(refComponente, evt) {
        if (evt.key == 'Enter') {
            evt.preventDefault()
            if (refComponente === 'refFechaNacimiento') {
                //this.refFechaNacimiento.refs.input.focus() // OK para el wrapper
                this.refFechaNacimiento.refs.input.focus() // OK para el date2
            } else if (refComponente === 'refComuna') {
                this.refComuna.refs.input.refs.inner.open() // OK para el date2
            } else if (refComponente === 'refSexo') {
                this.refSexo.refs.input.focus()
                this.refSexo.refs.input.refs.inner.open()
            } else if (refComponente === 'refIdBanco') {
                this.refIdBanco.refs.input.focus()
                this.refIdBanco.refs.input.refs.inner.open()
            } else if (refComponente === 'refIdTipoCuenta') {
                this.refIdTipoCuenta.refs.input.focus()
                this.refIdTipoCuenta.refs.input.refs.inner.open()
            } else if (refComponente === 'refRegion') {
                this.refRegion.refs.input.focus()
                this.refRegion.refs.input.refs.inner.open()
            } else if (refComponente === 'refOtraNacionalidad') {
                this.refOtraNacionalidad.refs.input.focus()
                this.refOtraNacionalidad.refs.input.refs.inner.open()
            } else if (refComponente === 'refIdCaptador') {
                this.refIdCaptador.refs.input.focus()
                this.refIdCaptador.refs.input.refs.inner.open()
            } else {
                ReactDOM.findDOMNode(this[refComponente].refs.input).select()
            }
            // console.log( ReactDOM.findDOMNode(this.refNombre1).focus() ) // OK
            // console.log( ReactDOM.findDOMNode(this.refNombre1.refs.input).focus() ) // OK
            return
        }
    }
    getChildContext() {
        return {
            uploadDNIFront: (idUser, file) => {
                let data = new FormData()
                data.append('DNIFront', file)
                let request = api.usuario(idUser).uploadOperadorFile(data)
                request
                    .then(response => {
                        this.refs.notificator.success("CARNET", "Foto frontal agregada correctamente", 4 * 1000);
                        this.setState({
                            checkDNIFront: true
                        })
                    })
                    .catch(this.ajaxErrorHandler('Error al subir foto frontal carnet'))
                return request
            },
            uploadDNIBack: (idUser, file) => {
                let data = new FormData()
                data.append('DNIBack', file)
                let request = api.usuario(idUser).uploadOperadorFile(data)
                request
                    .then(response => {
                        this.refs.notificator.success("CARNET", "Foto posterior agregada correctamente", 4 * 1000);
                        this.setState({
                            checkDNIBack: true
                        })
                    })
                    .catch(this.ajaxErrorHandler('Error al subir foto posterior carnet'))
                return request
            },
            uploadFechaVenc: (idUser, fecha, event) => {
                let data = new FormData()
                data.append('fecha', fecha)
                //console.log(fecha)
                event.preventDefault()
                let request = api.usuario(idUser).uploadFechaVenc(data)
                request
                    .then(response => {
                        this.refs.notificator.success("CARNET", "Fecha de vencimiento agregada correctamente", 4 * 1000);
                        this.setState({
                            chekcFechaVenc: true
                        })
                    })
                    .catch(this.ajaxErrorHandler('Error al subir fecha de vencimiento carnet'))
                return request
            }
        }
    }


    render() {
        //console.log(this.props.usuario)
        let arrayCaptadores = this.props.usuario.idCaptador != 658 ?
            this.props.usuario.captadores.filter(cap => cap.idCaptador != 658) : this.props.usuario.captadores
        let bancoEstado = this.props.usuario.bancos.filter((b) => b.nombreCorto == 'Banco Estado')
        let otrosBancos = this.props.usuario.bancos.filter((b) => b.nombreCorto != 'Banco Estado')
        let bancosSorted = bancoEstado.concat(otrosBancos)
        let regionesSorted = this.props.usuario.regiones.filter(r => r.cutRegion < 20)
        return (
            <div>
                <div>
                    {//console.log(this.props.usuario)
                    }
                    < ReactNotify ref='notificator' className={ReactNotifyCSS} />
                    <ModalConfirmar
                        showModal={this.state.showModal}
                        cancelModal={this.cancelModal}
                        confirmar={this.nuevoUsuario}
                        datos={this.state.datos}
                        comuna={this.state.comuna}
                        banco={this.state.banco}
                        cuenta={this.state.cuenta}
                        region={this.state.region}
                        captador={this.state.captador}
                        confirmando={this.state.confirmando}
                    />
                    <ModalUploadFiles
                        user={this.state.user}
                        showModal={this.state.modalDNI}
                        cancelModal={this.cancelModalDNI}
                        checkFront={this.state.checkDNIFront}
                        checkBack={this.state.checkDNIBack}
                        checkFechaVenc={this.state.chekcFechaVenc}
                    />
                    <Form
                        className="form-horizontal"
                        schema={this.usuarioSchema}
                        defaultValue={this.usuarioSchema.default()}
                        delay={1000}
                        noValidate={true}
                        onSubmit={this.mostrarModal}
                        onInvalidSubmit={this.enviarFormularioInvalido.bind(this)}
                    >

                        <div className="row">
                            <div className="col-md-6">
                                <h4 style={{ textAlign: 'center' }}>Datos Personales</h4>
                                {/* RUN */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">RUN (*)</label>
                                    <div className="col-sm-3">
                                        <Form.Field className="form-control" errorClass={cx('form__field--error')}
                                            name='usuarioRUN'
                                            //disabled={true}
                                            mapValue={{
                                                usuarioRUN: usuarioRUN => usuarioRUN,
                                                usuarioDV: usuarioRUN => obtenerVerificador(usuarioRUN)
                                            }}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refNombre1')}
                                            required
                                        />
                                    </div>
                                    <div className="col-sm-2">
                                        <Form.Field className="form-control" errorClass={cx('form__field--error')}
                                            name='usuarioDV'
                                            disabled={true}
                                            ref={ref => this.refUsuarioDV = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refNombre1')}
                                            required
                                        />
                                    </div>
                                    <div className="col-sm-5">
                                        <Form.Message for={['usuarioRUN', 'usuarioDV']} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {/* Nombres */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Nombres (*)</label>
                                    <div className="col-sm-5">
                                        <Form.Field className="form-control" errorClass={cx('form__field--error')} placeholder='Primer Nombre'
                                            name='nombre1'
                                            ref={ref => this.refNombre1 = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'nombre2')}
                                            required
                                        />
                                        <Form.Message for={'nombre1'} errorClass={cx('form__message-error')} />
                                    </div>
                                    <div className="col-sm-5">
                                        <Form.Field className="form-control" placeholder='Segundo Nombre'
                                            name='nombre2'
                                            ref={ref => this.refNombre2 = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refApellidoPaterno')}
                                            required
                                        />
                                        <Form.Message for={'nombre2'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {/* Apellidos */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Apellidos (*)</label>
                                    <div className="col-sm-5">
                                        <Form.Field className="form-control" errorClass={cx('form__field--error')} placeholder='Apellido Paterno'
                                            name='apellidoPaterno'
                                            ref={ref => this.refApellidoPaterno = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refApellidoMaterno')}
                                            required
                                        />
                                        <Form.Message for={'apellidoPaterno'} errorClass={cx('form__message-error')} />
                                    </div>
                                    <div className="col-sm-5">
                                        <Form.Field className="form-control" placeholder='Apellido Materno'
                                            name='apellidoMaterno'
                                            ref={ref => this.refApellidoMaterno = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refFechaNacimiento')}
                                            required
                                        />
                                        <Form.Message for={'apellidoMaterno'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>

                                {/* Fecha Nacimiento */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Fecha Nacimiento (*)</label>
                                    <div className="col-sm-5">
                                        {/*<input type="date"/>*/}
                                        <Form.Field type='date2' time={false} errorClass={cx('form__field--error')} placeholder='Ej. 31-07-2016'
                                            name='fechaNacimiento'
                                            format='D-M-YYYY'
                                            editFormat='D-M-YYYY'
                                            ref={ref => this.refFechaNacimiento = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refSexo')}
                                            required
                                        />
                                        <Form.Message for={'fechaNacimiento'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {/* Sexo */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Sexo (*)</label>
                                    <div className="col-sm-5">
                                        <Form.Field name='sexo' errorClass={cx('form__field--error')}
                                            type='dropdownlist'
                                            data={['Masculino', 'Femenino', 'Otro']}
                                            duration={0}
                                            ref={ref => this.refSexo = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refNacionalidad')}
                                            required
                                        />
                                        <Form.Message for={'sexo'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {/*Nacionalidad*/}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Nacionalidad (*)</label>
                                    <div className="col-sm-5">
                                        <Form.Field type='dropdownlist' errorClass={cx('form__field--error')}
                                            name='nacionalidad'
                                            data={['Chilena', 'Venezolana', 'Otra']}
                                            ref={ref => this.refNacionalidad = ref}
                                            duration={10}
                                            onKeyPress={this.state.inputNacion ? this.siguienteComponente.bind(this, 'refOtraNacionalidad')
                                                : this.siguienteComponente.bind(this, 'refTelefono')}
                                            onChange={(e) => this.changeNacionalidad(e)}
                                            required
                                        />
                                        <Form.Message for={'nacionalidad'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {this.state.inputNacion ?
                                    <div className={cx("form-group", 'form__control-label')}>
                                        <label className="col-sm-2 control-label">Nacionalidad (*)</label>
                                        <div className="col-sm-5">
                                            <Form.Field className="form-control" placeholder='Escriba su nacionalidad'
                                                name='otraNacionalidad'
                                                ref={ref => this.refOtraNacionalidad = ref}
                                                onKeyPress={this.siguienteComponente.bind(this, 'refCarnetFrente')}
                                                required
                                            />
                                            <Form.Message for={'otraNacionalidad'} errorClass={cx('form__message-error')} />
                                        </div>
                                    </div>
                                    : null
                                }
                                {/*<h4 style={{ textAlign: 'center' }}>Documento de identidad</h4>
                            <div className={cx("form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Foto frontal (*)</label>
                                <div className="col-sm-2">
                                    <Form.Field type='file' errorClass={cx('form__field--error')}
                                        name='DNIFront'
                                        //data={['Chilena', 'Venezolana', 'Otra']}
                                        ref={ref => this.refDNIFront = ref}
                                        //duration={10}
                                        onKeyPress={this.siguienteComponente.bind(this, 'refTelefono')}
                                        //onChange={(e) => this.changeNacionalidad(e)}
                                        required
                                    />
                                    <Form.Message for={'DNIFront'} errorClass={cx('form__message-error')} />
                                </div>
                            </div>
                            <div className={cx("form-group", 'form__control-label')}>
                                <label className="col-sm-2 control-label">Foto posterior (*)</label>
                                <div className="col-sm-2">
                                    <Form.Field type='file' errorClass={cx('form__field--error')}
                                        name='DNIBack'
                                        //data={['Chilena', 'Venezolana', 'Otra']}
                                        ref={ref => this.refDNIBack = ref}
                                        //duration={10}
                                        onKeyPress={this.siguienteComponente.bind(this, 'refTelefono')}
                                        //onChange={(e) => this.changeNacionalidad(e)}
                                        required
                                    />
                                    <Form.Message for={'DNIBack'} errorClass={cx('form__message-error')} />
                                </div>
                            </div>*/}
                            </div>
                            <div className="col-md-6">
                                <h4 style={{ textAlign: 'center' }}>Contacto</h4>
                                <div className={cx("telefonos")}>
                                    <p>Pedimos que los teléfonos ingresados sean verídicos, ya que esta información será utilizada más adelante.</p>
                                </div>
                                {/* Telefono */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Telefonos (*)</label>
                                    <div className="col-sm-5" style={{ display: 'flex', flexDirection: 'row' }}>
                                        <input className="form-control" type="text" disabled readOnly value="+56" style={{ textAlign: 'center' }} />
                                        <Form.Field className="form-control" placeholder='978164162'
                                            name='telefono'
                                            ref={ref => this.refTelefono = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refTelefonoEmergencia')}
                                            required
                                        />
                                        <Form.Message for={'telefono'} errorClass={cx('form__message-error')} />
                                    </div>
                                    <div className="col-sm-5" style={{ display: 'flex', flexDirection: 'row' }}>
                                        <input className="form-control" type="text" disabled readOnly value="+56" style={{ textAlign: 'center' }} />
                                        <Form.Field className="form-control" placeholder='Telefono Emergencia'
                                            name='telefonoEmergencia'
                                            ref={ref => this.refTelefonoEmergencia = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refEmailPersonal')}
                                            required
                                        />
                                        <Form.Message for={'telefonoEmergencia'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {/* Email */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Email (*)</label>
                                    <div className="col-sm-5">
                                        <Form.Field className="form-control" placeholder='Email personal'
                                            name='emailPersonal'
                                            ref={ref => this.refEmailPersonal = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refRegion')}
                                            required
                                        />
                                        <Form.Message for={'emailPersonal'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {/* Region */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Region (*)</label>
                                    <div className="col-sm-5">
                                        <Form.Field type='dropdownlist' errorClass={cx('form__field--error')}
                                            name='cutRegion'
                                            data={regionesSorted}
                                            valueField='cutRegion'
                                            textField='nombre'
                                            //filter='startsWith'
                                            mapValue={{ 'cutRegion': region => region.cutRegion }}
                                            duration={10}
                                            ref={ref => this.refRegion = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refComuna')}
                                            onChange={(r) => this.changeRegion(r)}
                                            required
                                        />
                                        <Form.Message for={'cutRegion'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {/* Comuna */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    {/*
                                 <label className="col-sm-2 control-label">Región</label>
                                 <div className="col-sm-4">
                                 <Form.Field name='cutRegion' type='select'>
                                 <option >Select a color...</option>
                                 <option value={0}>Red</option>
                                 <option value={1}>Yellow</option>
                                 <option value={2}>Blue</option>
                                 <option value={3}>other</option>
                                 </Form.Field>
                                 <Form.Message for={'cutRegion'} errorClass={cx('form__message-error')}/>
                                 </div>
                                 */}
                                    <label className="col-sm-2 control-label">Comuna (*)</label>
                                    <div className="col-sm-5">
                                        <Form.Field type='dropdownlist' errorClass={cx('form__field--error')}
                                            name='cutComuna'
                                            data={this.state.comunas.length > 0 ? this.state.comunas : this.props.usuario.comunas}
                                            valueField='cutComuna'
                                            textField='nombre'
                                            //groupBy='cutProvincia'
                                            filter='startsWith'
                                            mapValue={{ 'cutComuna': comuna => comuna.cutComuna }}
                                            duration={10}
                                            ref={ref => this.refComuna = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refDireccion')}
                                            required
                                        />
                                        <Form.Message for={'cutComuna'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {/* Direccion */}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Dirección (*)</label>
                                    <div className="col-sm-10">
                                        <Form.Field className="form-control" placeholder='Dirección'
                                            name='direccion'
                                            ref={ref => this.refDireccion = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refIdCaptador')}
                                            required
                                        />
                                        <Form.Message for={'direccion'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                {/*Captador*/}
                                <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Captador (*)</label>
                                    <div className="col-sm-5">
                                        <Form.Field type='dropdownlist' errorClass={cx('form__field--error')}
                                            name='idCaptador'
                                            data={this.state.captadores.length > 0 ? this.state.captadores : arrayCaptadores}
                                            //data={this.state.captadores.length > 0 ? this.state.captadores : captadoresFinal}
                                            valueField='idCaptador'
                                            textField='nombre'
                                            //groupBy='cutProvincia'
                                            filter='startsWith'
                                            mapValue={{ 'idCaptador': captador => captador.idCaptador ? captador.idCaptador : "" }}
                                            ref={ref => this.refIdCaptador = ref}
                                            duration={10}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refIdBanco')}
                                            required
                                        />
                                        <Form.Message for={'nacionalidad'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>
                                <h4 style={{ textAlign: 'center' }}>Datos Bancarios</h4>
                                {/* Banco */}
                                {<div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Banco (*)</label>
                                    <div className="col-sm-6">

                                        <Form.Field type='dropdownlist' errorClass={cx('form__field--error')}
                                            name='idBanco'
                                            data={bancosSorted}
                                            valueField='idBanco'
                                            textField='nombreCorto'
                                            filter='startsWith'
                                            mapValue={{ 'idBanco': banco => banco.idBanco }}
                                            duration={10}
                                            ref={ref => this.refIdBanco = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refIdTipoCuenta')}
                                            onChange={(c) => this.bcoEstado(c)}
                                            required
                                        />
                                        <Form.Message for={'idBanco'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>}
                                {/* Tipo Cuenta */}
                                {<div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Tipo Cuenta (*)</label>
                                    <div className="col-sm-6">
                                        <Form.Field type='dropdownlist' errorClass={cx('form__field--error')}
                                            name='idTipoCuenta'
                                            data={this.props.usuario.cuentas}
                                            valueField='idCuenta'
                                            textField='nombreCuenta'
                                            filter='startsWith'
                                            mapValue={{ 'idTipoCuenta': cuenta => cuenta.idCuenta }}
                                            duration={10}
                                            ref={ref => this.refIdTipoCuenta = ref}
                                            onKeyPress={this.siguienteComponente.bind(this, 'refNumeroCuenta')}
                                            onChange={(c) => this.cuentaRut(c)}
                                            required
                                        />
                                        <Form.Message for={'tipoCuenta'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>}
                                {/* numero Cuenta*/}
                                {this.state.bcoEstado && this.state.ctaRut ? null : <div className={cx("form-group", 'form__control-label')}>
                                    <label className="col-sm-2 control-label">Numero Cuenta (*)</label>
                                    <div className="col-sm-6">
                                        <Form.Field className="form-control" name='numeroCuenta' placeholder='Ej. 123-456-789-9'
                                            ref={ref => this.refNumeroCuenta = ref}
                                            required
                                        />
                                        <Form.Message for={'numeroCuenta'} errorClass={cx('form__message-error')} />
                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div className="row">
                            <div className={cx("col-sm-12", 'form__footer')}>
                                <a className="btn btn-default" href='/operadores'>Cancelar</a>
                                <Form.Button type='submit' className="btn btn-primary">Confirmar</Form.Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}

RegistroOperador.propTypes = {
    usuario: PropTypes.object,
    enviarFormulario: PropTypes.func,
    cancelarFormulario: PropTypes.func,
    comunas: PropTypes.array,
    captadores: PropTypes.array,
    bancos: PropTypes.array,
    cuentas: PropTypes.array,
    regiones: PropTypes.array,
    btnTexto: PropTypes.string
}

RegistroOperador.childContextTypes = {
    uploadDNIFront: PropTypes.func,
    uploadDNIBack: PropTypes.func,
    uploadFechaVenc: PropTypes.func,
    //uploadCertificate: PropTypes.func,
    //uploadContract: PropTypes.func,
    //uploadCredential: PropTypes.func,
    progressStatusDocumentation: PropTypes.func,
    isWrongFile: PropTypes.func,
}



// WEBPACK FOOTER //
// ./frontEnd/registro-operador/registro.jsx